import { useQuery, useSubscription } from '@apollo/client';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import GetUnreadNotificationsQuery from '../queries/GetUnreadNotificationsQuery';
import LargePrizeNotificationsSubscription from '../queries/LargePrizeNotificationsSubscription';

import {
  TXTWCL_Responsible_Gaming_Reminder,
  TXTWCL_Your_winnings_can_be_withdrawn_ELL
} from './BigWinningsSubscription.messages.json';

const BigWinningsSubscription = () => {
  const { idpToken } = useSelector(select.session.get);
  const [fetched, setFetched] = React.useState(false);
  const { modal } = useDispatch<Dispatch>();
  const { path } = useSelector(select.modal.getCurrent) || {};
  const { formatMessage } = useIntl();

  const enableBigWinningsSubscription = useFeature(FeatureFlag.EnableBigWinningsGQLSubscription);

  const largePrizeModalConfig = {
    path: '/notifications/simple-notification',
    locationState: {
      title: formatMessage(TXTWCL_Responsible_Gaming_Reminder),
      msg: formatMessage(TXTWCL_Your_winnings_can_be_withdrawn_ELL)
    }
  };

  useQuery(GetUnreadNotificationsQuery, {
    fetchPolicy: 'no-cache',
    skip: !enableBigWinningsSubscription || path === '/notifications/login-information' || fetched,
    onCompleted: (data) => {
      setFetched(true);
      if (data.getUnreadNotifications.length) {
        modal.unique(largePrizeModalConfig);
      }
    }
  });

  useSubscription(LargePrizeNotificationsSubscription, {
    skip: !enableBigWinningsSubscription || !idpToken,
    shouldResubscribe: !idpToken,
    onData: () => {
      modal.unique(largePrizeModalConfig);
    }
  });

  return null;
};

export default BigWinningsSubscription;
